import { CSSProperties } from 'react';
import { AdvancedSelectComponent, AdvancedSubHeaderComponent, BasicCheckboxComponent } from '@vivli/shared/components';
import { amrFieldTitleStyle, inputGroupBreakStyle } from '../../search-filters.styles';
import { FilterGroupComponent } from '../../filter-group.component';
import { useAmrSearchOptionsContext } from '@vivli/features/search/infrastructure/context';
import { useSearchApiContext } from '@vivli/core/infrastructure/context';

const checkboxContainerStyle: CSSProperties = {
    display: 'flex',
    marginBottom: '10px',
};

const checkboxStyle: CSSProperties = {
    transform: 'scale(1.5)',
    marginRight: '20px',
};

export const FifthFilterGroupComponent = () => {
    const { amrFilterValues } = useSearchApiContext();
    const {
        sampleSourceSelectedOptions,
        setSampleSourceSelectedOptions,
        includePediatricsInfo,
        setIncludePediatricsInfo,
        includeGenotypeInfo,
        setIncludeGenotypeInfo,
        includeOutcomesInfo,
        setIncludeOutcomesInfo,
    } = useAmrSearchOptionsContext();

    const specimenOptions = amrFilterValues?.specimenSources.map((l) => ({ value: l.value, label: l.value }));

    const handleGenotypeChanged = (checked: boolean) => {
        setIncludeGenotypeInfo(checked);
    };

    const handlePediatricsChanged = (checked: boolean) => {
        setIncludePediatricsInfo(checked);
    };
    const handleOutcomesChanged = (checked: boolean) => {
        setIncludeOutcomesInfo(checked);
    };

    return (
        <FilterGroupComponent>
            <div style={inputGroupBreakStyle}>
                <AdvancedSubHeaderComponent title={'Sources of Samples'} style={amrFieldTitleStyle} />
                <AdvancedSelectComponent
                    dataId={'amrSearchSourcesOfSamples'}
                    isMulti={true}
                    isSearchable={true}
                    onChange={setSampleSourceSelectedOptions}
                    options={specimenOptions}
                    selectedOptions={sampleSourceSelectedOptions}
                    menuPlacement={'top'}
                />
            </div>

            <div>
                <div style={checkboxContainerStyle}>
                    <BasicCheckboxComponent
                        style={checkboxStyle}
                        name={'genotypeCheckbox'}
                        checked={includeGenotypeInfo}
                        onChange={handleGenotypeChanged}
                    />
                    <label htmlFor="genotypeCheckbox">Includes Genotype Information</label>
                </div>
                <div style={checkboxContainerStyle}>
                    <BasicCheckboxComponent
                        style={checkboxStyle}
                        name={'pediatricsCheckbox'}
                        checked={includePediatricsInfo}
                        onChange={handlePediatricsChanged}
                    />
                    <label htmlFor="pediatricsCheckbox">Includes Pediatrics Information</label>
                </div>
                <div style={checkboxContainerStyle}>
                    <BasicCheckboxComponent
                        style={checkboxStyle}
                        name={'outcomesCheckbox'}
                        checked={includeOutcomesInfo}
                        onChange={handleOutcomesChanged}
                    />
                    <label htmlFor="outcomesCheckbox">Includes Outcomes Information</label>
                </div>
            </div>
        </FilterGroupComponent>
    );
};
